import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {apiGetTurnstileTemplate} from "./Actions";
import {DefaultLoader} from "../../../components/DefaultLoader";
import TurnstileTemplateTable from "./TurnstileTemplateTable";
import {FiPlus} from "react-icons/fi";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";

const TurnstileTemplate = () => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user)

    useEffect(() => {
        user.activeAreal && getData(user.activeAreal.id)
    }, []);

    const getData = (arealId) => {
        setLoading(true);
        apiGetTurnstileTemplate(arealId, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání šablon turniketů nastala chyba.");
            setData(null)
            setLoading(false);
        })
    }

    return (
        <>
            {user.activeAreal && (
                <>
                    <PageHeader crumbs={[{label: "Šablony turniketů"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton link="/turnstile/template/add" text="PŘIDAT ŠABLONU" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {loading
                        ? <DefaultLoader text={"Načítám šablony turniketů..."}/>
                        : <TurnstileTemplateTable data={data}/>
                    }
                </>
            )}
        </>
    );
}
export default TurnstileTemplate;
